import store from "@/store";

const requireAccess =
  (checkFn, redirectTo = "/") =>
  (to, from, next) => {
    checkFn() ? next() : next(redirectTo);
  };

const requireProductGroup = (product, redirectTo = "/") =>
  requireAccess(() => {
    if (!product) {
      return false;
    }

    if (!store || !store.getters) {
      return false;
    }

    return store.getters.hasAccessToProductGroup(product);
  }, redirectTo);

const requireNotOnPrem = (redirectTo = "/login") => requireAccess(() => !store.getters.isOnPrem, redirectTo);

const requireStaging = (redirectTo = "/") => requireAccess(() => store.getters.isStaging, redirectTo);

export { requireAccess, requireProductGroup, requireNotOnPrem, requireStaging };
